// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1da2edf2] .ant-modal-body {\n  height: 60vh;\n  overflow-y: scroll;\n}\n", ""]);
// Exports
module.exports = exports;
